import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CustomMargin from '../../../components/custom-margin';
import { chunkArray } from '../../../components/functions';
import { truncateText } from '../../../components/functions';
import axios from 'axios';
import { PROXY } from '../../../components/constants';
import { formatTitleForURL } from '../../../components/functions';

export default function CardPost({ onLatestUpdate }) {
    const [visiblePost, setVisiblePost] = useState(6);
    const [posts, setPosts] = useState([]);
    const [hideButton, setHideButton] = useState(false);

    const chunkedPosts = chunkArray(posts.slice(0, visiblePost), 3);

    const clickMore = (add) => {
        setVisiblePost((prev) => prev + add);
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    useEffect(() => {
        if (visiblePost >= posts.length) {
            setHideButton(true);
        } else {
            setHideButton(false);
        }
    }, [visiblePost, posts]);

    const fetchPosts = () => {
        axios.get(`${PROXY}/fetch_posts`)
        .then(res => {
            const sortedPosts = res.data.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateB - dateA;
            });
            setPosts(sortedPosts)
            if(sortedPosts.length > 0) {
                onLatestUpdate(sortedPosts[0].date);
            }
        })
        .catch(err => console.error(err));
    }

    return (
        <div className='max-w-7xl'>
            <CustomMargin className='flex flex-col gap-5 p-5'>
                {chunkedPosts.map((postChunk, rowIndex) => (
                    <div key={rowIndex} className="flex sm:flex-col lg:flex-row gap-5">
                        {postChunk.map((post, postIndex) => {
                            const { truncated, isTruncated } = truncateText(post.details, 30);
                            return (
                                <div key={postIndex} className="group mb-5 flex flex-col overflow-hidden rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0c0c0c] shadow-xl shadow-black/20 transition duration-500 hover:-translate-y-1 hover:border-zinc-500 sm:w-full lg:w-1/3">
                                    <img alt={post.title} src={`${PROXY}/uploads/images/${post.image}`} className="h-96 w-full object-cover grayscale transition duration-700 group-hover:grayscale-0" />
                                    <div className="mt-0 flex flex-1 flex-col justify-start p-6">
                                        <small className="font-mono text-xs tracking-[0.1em] text-zinc-500">{post.date} | Quilaton Law Office</small>
                                        <h2 className="mt-3 font-fontMontserrat text-2xl text-zinc-100">{post.title}</h2>
                                        <p className="mt-3 flex-1 leading-7 text-zinc-400">{truncated}</p>
                                        <Link to={`/practices/posts/${formatTitleForURL(post.title)}/`} className="mt-6 text-sm tracking-[0.12em] text-zinc-200 transition hover:text-white hover:underline">
                                            Read more
                                        </Link>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </CustomMargin>
            <div className='lg:p-5 sm:p-5'>
                <button
                    onClick={() => clickMore(3)}
                    className={`mb-10 rounded-xl border border-zinc-600 bg-gradient-to-b from-zinc-800 to-zinc-950 px-10 py-4 text-sm tracking-[0.16em] text-zinc-100 transition-all duration-300 hover:border-zinc-300 hover:shadow-lg hover:shadow-black ${hideButton ? 'hidden' : ''}`}
                >
                    MORE POSTS
                </button>
            </div>
        </div>
    );
}
